import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';

const SrMyCartBannerBlock = styled.div`
    width: ${isMobileOnly?"100vw":"100%"};
    ${isMobileOnly&&`margin-left: -4vw`};
    height: 76px;
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    background-color: #ffffff;
    vertical-align: bottom;
`;

const SrMyCartBanner = () => {
    return (
        <Link to={"/ct"}>
            <SrMyCartBannerBlock img={"/assets/images/icon/es_move-btn_210123.png"} />
        </Link>
    );
};

export default SrMyCartBanner;
